export default __webpack_public_path__ + "static/mazuis-review-italic-b5d75836c30a8e67fe5a0c81e5ae18bf.woff2";